<template>
  <div class="login">
    <p class="log-title" @click="goLogin">登陆账号选择</p>
    <div class="log-logo"><img src="../../static/img/logo.png" alt=""> </div>
    <form action="">
      <div class="log-input">
        <div class="input-item">
          <van-field
              v-model="accountName"
              label="账号类型"
              left-icon="eye-o"
              right-icon="arrow"
              input-align="right"
              placeholder="请点击选择"
              @click="typeCloose=true"
              readonly
            />
        </div>
      </div>
    </form>
    <div class="log-btn"><button @click="loginSubmit()">登录</button></div>
    <van-popup v-model="typeCloose" round position="bottom">
      <van-picker
        title="账号类型"
        show-toolbar
        :columns="accountTypeList"
        @confirm="
          (value) => {
            onConfirm(value);
          }
        "
        @cancel="typeCloose = false"
      />
    </van-popup>
  </div>

</template>

<script>
import { Api } from '../utils/axios'
export default {
  data () {
    return {
      accountType:'',
      accountName:'',
      typeCloose:false,
      accountTypeList:[{'text':'普通账号','value':'1'},{'text':'双学位账号','value':'2'}]
    }
  },
  beforeCreate(){
    sessionStorage.removeItem('thirdLogin');
    sessionStorage.setItem('isNeedLogout',"1")
    //sessionStorage.removeItem('isNeedLogout')
    //sessionStorage.setItem('menuSave',0)
    //sessionStorage.setItem('ifSelect',0)
  },
  created(){
    //sessionStorage.setItem('isNeedLogout',true)
  },
  methods:{
    onConfirm(item){
      this.accountType = item.value;
      this.accountName = item.text;
      this.typeCloose = false;
    },
    async login(){
      const data = {
        token:this.$route.query.token,
        accountType:this.accountType,
        toMenu:this.$route.query.toMenu,
      }
      const res = await Api.toChooseTypeLogin(data)
      if(res.code == 1){
        sessionStorage.setItem('Identity', res.data.userType);
        sessionStorage.setItem('Token', res.data.token);
        if(sessionStorage.getItem('schoolCode')=="10013"){ 
            this.$router.replace("/new/Home_10013");
         }else{ 
            this.$router.replace('/homeIndex')
         }
        
      }else{
        Toast.fail(res.Msg);
        this.$router.replace("/casLogin");
      }
    },
    loginSubmit(){
      if(this.accountType == '' || this.accountName == ''){
        this.$toast.fail('请填选择账号类型！')
      }else{
        this.login()
      }
    },
    goLogin(){
      this.$router.replace("/login");
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  .log-title{font-size: 19px;color: @attendance-color-1;font-weight:600;margin:-20px 36px 27px;}
  .log-logo{text-align: center;padding: 28px 0 49px;}
  .log-logo img{width: 77px;height: 77px;}
  .log-input{padding: 0 36px;}
  .log-input p{color: @attendance-color-2 ;margin-bottom: 11px;}
  .input-item,.input-active{display: flex;align-items: center;padding-bottom: 10px;justify-content: space-between;margin-bottom: 24px;}
  .input-item{border-bottom: 1px solid @attendance-border-color-3;}
  .input-active{border-bottom: 1px solid @attendance-color-2 ;}
  .input-item input,.input-active input{font-size: 24px;color: @attendance-color-1;width: 90%;padding: 0 4px;background-color: @attendance-color-3;}
  .delete-icon{background: url(../../static/img/delete.png)no-repeat center;width: 16px;height: 16px;background-size: 16px 16px;}
  .input-item input::placeholder,.input-active input::placeholder{font-size: 20px;}
  .log-btn{text-align: center;}
  .log-btn button{background-color: @attendance-background-color-1;padding: 11px 0;width: calc(~"100% - 40px");color: @attendance-color-3;border-radius: 3px;margin-top: 33px;}
</style>



// WEBPACK FOOTER //
// src/components/chooseTypeLogin.vue